import { render, staticRenderFns } from "./ImportEnroll.vue?vue&type=template&id=0a5c1754&scoped=true&"
import script from "./ImportEnroll.vue?vue&type=script&lang=js&"
export * from "./ImportEnroll.vue?vue&type=script&lang=js&"
import style0 from "./ImportEnroll.vue?vue&type=style&index=0&id=0a5c1754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5c1754",
  null
  
)

export default component.exports